<template>
  <div
    class="winRatePrediction"
    ref="parentDom"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="barEcharts">
      <div
        ref="barEcharts"
        class="barEchartsDom"
        :style="{
          height: `${parentDomHPx ? parentDomHPx : 'auto'}`,
        }"
        @click="clickEchartBox"
      ></div>
    </div>
  </div>
</template>

<script>
// 胜率预测 bar
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'winRatePrediction',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homeBgColor: ['rgba(235, 27, 80, 1)', 'rgba(235, 27, 80, 1)'], //主队：【坐标轴颜色，柱状条颜色】
      awayBgColor: ['rgb(0, 207, 183, 1)', 'rgb(0, 207, 183, 1)'], //客队：【坐标轴颜色，柱状条颜色】
      otherColor: ['rgba(255,255,255,1)', 'rgba(255,255,255,1)'], //[分钟刻度字颜色，平局颜色]
      initFlag: false,
      resizeFlag: false,
      myChart: null,
      yAxisMax: 100,
      maxMinTime: 90, //比赛最大分钟
      homeData: [],
      awayData: [],
      xAxisTimeInterval: 5, //时间轴 分割值
      parentDomHPx: null,
      xAixstextBgIcon:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAACkAgMAAADKwbkWAAAACVBMVEUAAAAAAAAAAACDY+nAAAAAAnRSTlMAf7YpoZUAAADjSURBVFjD7c6xEcJADERRSBRQAtXQDqpGJRCQ6KrE47mxbOvuJzBE2vQF+y8/3pP52h7o0gz93t7o2pzvGwbI4ob3DQN0ccd7DJDVje4xQFd3uMcA6W5wTwHa3eEeAmRzm91jgG7uk3sMkJ3b+B4DdOc+vMcAObiN7jFAD+58nwPk5JbvMUBP7ukeAyS5pXsK0OSe7iFABm54HwFxnwPiHgNk6La/xwAduvN9BMjELe4xQCfucU8BMnWLewjQqXu/xwABt35PAQru/R4CBN0uN/RXeXl5eXl5eXl5eXn53/zLfQBxDTJH1ZLrgAAAAABJRU5ErkJggg==',
    }
  },
  created() {},
  mounted() {
    this.initData()
    this.isInitEChart()
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      window.removeEventListener('resize', this.onResizeEvent)
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.homeData = []
    this.awayData = []
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        const dataList = newVal.data ? newVal.data : []
        this.homeData =
          dataList.homeList && dataList.homeList.length > 0
            ? dataList.homeList
            : []
        this.awayData =
          dataList.awayList && dataList.awayList.length > 0
            ? dataList.awayList
            : []
        if (
          this.maxMinTime == 90 &&
          (this.homeData.length > 18 || this.awayData.lengh > 18)
        ) {
          this.maxMinTime = 120
        }
        if (this.initFlag) {
          this.initEcharts()
          if (!this.resizeFlag) {
            this.resizeFlag = false
            this.myChart.resize()
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    initData() {
      // this.homeData = [
      //   0, 20, 40, 30, 10, 60, 30, 40, 10, 30, 40, 50, 60, 70, 80, 30,
      // ]
      // this.awayData = [
      //   10, 20, 30, 50, 70, 30, 30, 40, 70, 50, 40, 30, 20, 10, 10, 50,
      // ]
      // this.homeData = [0, 20, 40, 30, 10, 60, 50]
      // this.awayData = [10, 20, 30, 50, 70, 30, 20]
    },
    isInitEChart() {
      this.setTimeoutId = setTimeout(() => {
        if (this.$refs.parentDom && this.$refs.parentDom.clientWidth) {
          clearTimeout(this.setTimeoutId)
          this.parentDomHPx = `${Math.ceil(
            this.$refs.parentDom.clientWidth / 2.233
          )}px`
          this.$nextTick(() => {
            this.initEcharts()
            this.initFlag = true
            this.myChart.on('click', 'series.line', (params) => {
              console.debug(params)
              if (params.componentType == 'markPoint') {
                // 点击了 markPoint
                this.isMarkFlag = true
              }
            })
            window.addEventListener('resize', this.onResizeEvent)
          })
        } else {
          this.isInitEChart()
        }
      }, 50)
    },
    onResizeEvent() {
      this.myChart.resize()
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      const clientWidth = this.$refs.barEcharts.clientWidth
      const fontSize = Math.round((10 / 375) * clientWidth)
      const arrowSize = Math.round((4 / 375) * clientWidth)
      const maxMinTime = this.maxMinTime
      const xAxisTimeSeriesData = []
      let leftWidth = Math.round(0.004 * clientWidth)
      // console.debug('dpi:', dpi, leftWidth * dpi)
      for (let i = 0; i <= maxMinTime; i = i + this.xAxisTimeInterval) {
        xAxisTimeSeriesData.push({
          value: `${i}`,
          textStyle: {
            fontSize: Math.ceil(fontSize / 2),
            color: this.otherColor[0],
            backgroundColor: {
              image: this.xAixstextBgIcon,
            },
            fontWeight: 'bold',
            fontFamily: 'Qatar2022',
            padding: [Math.ceil(fontSize * 0.75), 0, 0, 0],
            width: fontSize,
          },
        })
      }

      let option = {
        title: {
          show: false,
          text: '胜率预测',
        },
        tooltip: {
          show: false,
        },
        grid: {
          top: '5%',
          bottm: '11%',
          left: '6%',
          right: '6%',
          width: '88%',
          height: '84%',
        },
        legend: {
          show: false,
        },
        color: [this.homeBgColor[1], this.awayBgColor[1]],
        xAxis: {
          type: 'category',
          offset: -2,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          data: xAxisTimeSeriesData,
        },
        color: [this.homeBgColor[1], this.awayBgColor[1]],
        yAxis: [
          {
            type: 'value',
            max: 100,
            axisLabel: {
              show: true,
              fontSize,
              color: this.otherColor[1],
              formatter: function (value, index) {
                return (value / 100).toFixed(1)
              },
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              opacity: 1,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ['none', 'arrow'],
              onZeroAxisIndex: 0,
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [0, arrowSize],
              lineStyle: {
                width: leftWidth, //(dpi*leftWidth).toFixed(1)
                color: this.homeBgColor[0],
                cap: 'square',
              },
            },
          },
          {
            type: 'value',
            max: 100,
            inverse: true,
            axisLabel: {
              show: true,
              fontSize,
              color: this.otherColor[1],
              formatter: function (value, index) {
                return (value / 100).toFixed(1)
              },
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              opacity: 1,
            },
            splitLine: {
              show: false,
            },
          },
          {
            offset: 0,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ['arrow', 'none'],
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [arrowSize * -1, 20],
              lineStyle: {
                width: leftWidth,
                color: this.awayBgColor[0],
                cap: 'square',
              },
            },
          },
        ],
        series: [
          {
            name: '主队',
            type: 'bar',
            yAxisIndex: 0,
            showBackground: true,
            backgroundStyle: {
              color: this.otherColor[1],
              opacity: 1,
            },
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            data: this.homeData,
          },
          {
            name: '客队',
            type: 'bar',
            yAxisIndex: 1,
            // xAxisIndex: 2,
            barGap: '-100%',
            backgroundStyle: {
              color: this.awayBgColor[1],
              opacity: 1,
            },
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            data: this.awayData,
          },
        ],
      }
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.barEcharts)
      }
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.barEcharts, true, 'uploadData')
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.winRatePrediction {
  position: relative;
  width: 80%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(133, 20, 54, 1);
  &.autoExportPng {
    width: 100%;
    height: 100%;
  }
  .barEcharts {
    width: 100%;
    height: 100%;
    .barEchartsDom {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
